module.exports = "https://static-production.npmjs.com/ecc2a793db0bd5966246e970f9c9ff5e.png";